import { FC, useEffect, useMemo, useState } from 'react';

import IconComponent from './IconComponent';

import { ICONS } from '../utils/enum/Icons';

interface Props {
    quantity: number;
    onChange: (newValue: number) => void;
    minimum: number;
    multiple: number;
    maximum?: number | null;
    disabledButtons?: boolean;
}

const QuantitySelectorComponent: FC<Props> = ({
    quantity = 0,
    onChange,
    minimum = 1,
    multiple = 1,
    maximum = null,
    disabledButtons = false,
}) => {
    const [value, setValue] = useState(0);

    const disableMinus = useMemo(() => {
        if (disabledButtons) {
            return true;
        }
        if (value == 0) {
            return true;
        }
        return false;
    }, [value, minimum, disabledButtons]);

    const disablePlus = useMemo(() => {
        if (disabledButtons) {
            return true;
        }
        if (maximum == null) {
            return false;
        }
        return false;
    }, [value, maximum, disabledButtons]);

    useEffect(() => {
        setValue(quantity);
    }, [quantity]);

    return (
        <div className="br-quantitySelector">
            <span
                className={`br-quantitySelector__action ${disableMinus && '-disabled'}`}
                onClick={() => {
                    if (!disableMinus) {
                        const newValue = value > minimum ? value - multiple : 0;
                        setValue(newValue);
                        onChange(newValue);
                    }
                }}
            >
                <IconComponent icon={ICONS.minus} />
            </span>
            <span className="br-quantitySelector__quantity">{value}</span>
            <span
                className={`br-quantitySelector__action ${disablePlus && '-disabled'}`}
                onClick={() => {
                    if (!disablePlus) {
                        const newValue = value + multiple;
                        setValue(newValue);
                        onChange(newValue);
                    }
                }}
            >
                <IconComponent icon={ICONS.plus_small} />
            </span>
        </div>
    );
};

export default QuantitySelectorComponent;
